import { defineMessages } from "react-intl"

export const MSGS = defineMessages({
  companyName: {
    id: "Claims.ContactDetails.companyName",
    description: "field company name of section constact details",
    defaultMessage: "Company Name"
  },
  customerNumber: {
    id: "Claims.ContactDetails.customerNumber",
    description: "field customer number of section constact details",
    defaultMessage: "Customer Number"
  },
  fullName: {
    id: "Claims.ContactDetails.name",
    description: "select Name of section constact details",
    defaultMessage: "Name"
  },
  lastname: {
    id: "Claims.ContactDetails.lastName",
    description: "select Last Name of section constact details",
    defaultMessage: "Last Name"
  },
  email: {
    id: "Claims.ContactDetails.email",
    description: "select email of section constact details",
    defaultMessage: "E-mail"
  },
  companyCountry: {
    id: "Claims.ContactDetails.companyCountry",
    description: "field company name of section constact details",
    defaultMessage: "Company Country"
  },
  minLength: {
    id: "Claims.Step1.Field.Validation.MinLength",
    defaultMessage: "Customer number must be at least {min} characters"
  },
  maxLength: {
    id: "Claims.Step1.Field.Validation.MaxLength",
    defaultMessage: "Customer number must not exceed {max} characters"
  },
  companyNameInvalidCharacters: {
    id: "Claims.Step1.Field.Validation.CompanyNameInvalidCharacters",
    defaultMessage: "Company name cannot contain special characters"
  }
})

const COUNTRIES_STATE_MSGS = defineMessages({
  GERMANY: {
    id: "Claims.companyCountry.option.GERMANY",
    description: "option original state for select",
    defaultMessage: "GERMANY"
  },
  SPAIN: {
    id: "Claims.companyCountry.option.SPAIN",
    description: "option trandformed state for select",
    defaultMessage: "SPAIN"
  },
  UNK: {
    id: "Claims.companyCountry.option.UNK",
    description: "option trandformed description state for select",
    defaultMessage: "UK"
  }
})

export const COUNTRIES_OPTIONS = [
  {
    value: "D",
    label: COUNTRIES_STATE_MSGS.GERMANY
  },
  {
    value: "ES",
    label: COUNTRIES_STATE_MSGS.SPAIN
  },
  {
    value: "UK",
    label: COUNTRIES_STATE_MSGS.UNK
  }
]
